/**
 * @hidden
 */
var canUseDOM = Boolean(
// from fbjs
typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement);
export { canUseDOM };
//# sourceMappingURL=canUseDOM.js.map